// src/context/ThemeContext.js

import { createContext, useContext, useState, useEffect } from 'react';
import { themes, getTheme } from '../styles/theme';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  // Check localStorage first, otherwise default to 'dark'
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('chainguard-theme');
    return saved || 'dark';
  });

  const colors = getTheme(theme);

  useEffect(() => {
    localStorage.setItem('chainguard-theme', theme);
    document.body.style.background = colors.bgPrimary;
  }, [theme, colors.bgPrimary]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, colors, themes }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}